import type { Translations } from './types';

const de: Translations = {
    // ── Navigation ───────────────────────────────────────
    next: 'Weiter',
    storyReadPrompt: 'Bitte lies zuerst die Geschichte.',
    backToStory: '← Zurück zur Geschichte',
    nextArrow: 'Weiter →',
    finishAssessment: 'Bewertung abschließen →',
    common_step: 'Schritt',

    // ── Question pages ───────────────────────────────────
    questionsStory1: 'Fragen — Geschichte 1',
    questionsStory2: 'Fragen — Geschichte 2',
    lastSetOfQuestions: 'Letzte Fragen — fast fertig! 🎉',
    typeAnswerHere: 'Schreib hier deine Antwort...',
    backCountSingular: '📖 Du bist {n} Mal zurückgekehrt, um die Geschichte erneut zu lesen.',
    backCountPlural: '📖 Du bist {n} Mal zurückgekehrt, um die Geschichte erneut zu lesen.',

    assessmentComplete: 'Bewertung abgeschlossen! 🎉',
    assessmentSubtitle: 'Du hast einen wichtigen Schritt zum Verständnis von Lernschwierigkeiten gemacht',
    returnToHome: 'Zurück zur Startseite',
    assessmentSuccessfullyCompleted: 'Bewertung erfolgreich abgeschlossen',
    amazingJob: 'Tolle Arbeit!',
    youCrushedIt: 'Du hast es geschafft! Das hast du erreicht:',
    whatsNext: 'Was kommt als nächstes?',
    getReadyForResults: 'Mach dich bereit für deine personalisierten Ergebnisse',
    youDidIt: 'Du hast es geschafft!',
    youDidItDesc:
      'Dein Engagement für das Verständnis von Lernschwierigkeiten ist wirklich inspirierend. Während andere vielleicht aufgegeben hätten, hast du es bis zum Ende durchgehalten!',

    heroLine1: 'LEGASTHENIE',
    heroLine2: 'SCREENING',
    heroTagline: 'in einer Sitzung',
    heroSubtitle:
      'Eine multimodale Testung im Browser, die Ihnen gleich danach einen schriftlichen Bericht liefert — ohne Praxistermin, ohne Warteliste, ohne Spezialgeräte.',
    heroBetaLabel: 'BETA',
    startAssessment: 'Jetzt starten',
    trustedBy: 'Vertraut von Pädagogen und Forschern weltweit',

    pfp_privacyBadge: 'Datenschutz & Compliance',
    pfp_privacyHeading: 'Wir nehmen Datenschutz ernst mit vollständiger DSGVO- und MDR-Compliance',
    pfp_formBadge: 'Bewertung starten',
    pfp_ctaHeading: 'LEGASTHENIE SCREENING',
    pfp_ctaDesc: 'Schließen Sie sich Tausenden an, die einzigartige Einblicke in ihren Lesestil durch unser KI-gestütztes Assessment entdeckt haben.',
    pfp_ctaFooter: 'Kein Zeitlimit • In eigenem Tempo • 100% vertraulich',
    pfp_whyTitle: 'Warum DysTest?',
    pfp_whySubtitle: 'Entdecken Sie, was unser KI-gestütztes Assessment zur genauesten und zuverlässigsten Lösung macht',
    pfp_whyDesc: 'DysTest kombiniert über 20 Jahre professionelle Expertise in der Legasthenieforschung mit lebenslanger Erfahrung. Durch das Reverse-Engineering, wie legasthenische und neurotypische Leser Text verarbeiten, lernt unsere KI, subtile Lesemuster zu unterscheiden, die traditionelle Tests übersehen.',
    pfp_feature1Title: 'Blickverfolgung, Tastenanschlag & Mehrsprachige Einblicke',
    pfp_feature1Desc: 'Fortschrittliche KI analysiert Augenbewegungen, Gesichtsausdrücke und Tastenanschläge, um Lernmuster aufzudecken, die für jeden Leser einzigartig sind — in jeder Sprache. DysTest passt sich intelligent an mehrsprachige Benutzer an.',
    pfp_feature2Title: 'Sofortige, Umsetzbare Ergebnisse',
    pfp_feature2Desc: 'Erhalten Sie klare, wissenschaftlich fundierte Einblicke in wenigen Minuten. Unsere Berichte übersetzen komplexe Daten in leicht verständliche Empfehlungen, die Eltern, Pädagogen und Lernende stärken.',
    pfp_feature3Title: 'Datenschutz & Compliance zuerst',
    pfp_feature3Desc: 'Ihre Daten sind verschlüsselt, anonymisiert und nach höchsten ethischen und regulatorischen Standards behandelt — vollständig konform mit DSGVO und MDR. Nichts wird über die Verbesserung Ihrer DysTest-Erfahrung hinaus geteilt.',
    pfp_feature4Title: 'Zugängliches, Menschenzentriertes Design',
    pfp_feature4Desc: 'DysTest ermöglicht Ihnen, in eigenem Tempo zu screenen — ruhig, intuitiv und ohne Druck. Für Inklusivität, Barrierefreiheit und sinnvolles Verständnis konzipiert, definiert es neu, wie Lernschwierigkeiten entdeckt werden.',
    pfp_finalCtaDesc: 'Starten Sie noch heute Ihr personalisiertes KI-gestütztes Legasthenie-Screening — entwickelt, um zu verstehen, wie Sie lesen, nicht nur was Sie lesen.',

    hiw_badge: 'Einfacher 8-Schritte-Prozess',
    hiw_heading: 'Wie die Bewertung funktioniert',
    hiw_subtext: 'Von der Registrierung bis zum detaillierten Legasthenie-Bewertungsbericht — vollständig im Browser, kein Download erforderlich.',
    hiw_step1Title: 'Registrieren',
    hiw_step1Desc: 'Geben Sie Ihren Namen, Ihr Alter und Ihre bevorzugte Sprache ein. Kein Konto erforderlich — dauert unter 2 Minuten.',
    hiw_step2Title: 'Augenkalibrierung',
    hiw_step2Desc: 'Folgen Sie 16 animierten Punkten auf dem Bildschirm. Der KI-Iris-Tracker erlernt Ihre einzigartige Blicksignatur.',
    hiw_step3Title: 'Wörter & Symbole',
    hiw_step3Desc: 'Ordnen Sie Wörter ihren Bildern zu, während wir Erkennungsgeschwindigkeit und visuell-phonologische Verarbeitung messen.',
    hiw_step4Title: 'RAN-Schnelltest',
    hiw_step4Desc: 'Benennen Sie so schnell wie möglich eine Abfolge von Farben oder Objekten. Misst die Abrufflüssigkeit.',
    hiw_step5Title: 'Geschichten & Fragen',
    hiw_step5Desc: 'Lesen Sie zwei altersgerechte Geschichten und beantworten Sie Verständnisfragen. Augenbewegungen und Blinzeln werden aufgezeichnet.',
    hiw_step6Title: 'Wortschreiben',
    hiw_step6Desc: 'Tippen Sie Wörter aus dem Gedächtnis. Tippzeitpunkte und Fehlermuster zeigen Rechtschreib- und motorische Verarbeitung.',
    hiw_step7Title: 'Feedback',
    hiw_step7Desc: 'Teilen Sie Ihre Erfahrungen und Bedenken mit. Dieser Kontext hilft bei der klinischen Interpretation.',
    hiw_step8Title: 'Ergebnisse erhalten',
    hiw_step8Desc: 'Erhalten Sie einen detaillierten Bericht mit Legasthenie-Risikoindikatoren, Blick-Heatmaps und Lesemetriken.',

    pf_whoTaking: 'Wer macht den Test?',
    pf_myself: 'Ich selbst',
    pf_myselfAge: 'Alter 13+',
    pf_child: 'Kind',
    pf_childAgeRange: 'Alter 5-12',
    pf_verifyEmailTitle: 'E-Mail verifizieren',
    pf_parentalConsentStepTitle: 'Elterliche Einwilligung',
    pf_verifyEmailDesc: 'Geben Sie den Code ein, der an Ihre E-Mail gesendet wurde, um die Registrierung abzuschließen',
    pf_consentDesc: 'Bitte überprüfen und geben Sie Ihre Einwilligung zur Datenverarbeitung',
    pf_yourName: 'Name des Teilnehmers *',
    pf_yourNamePlaceholder: 'Geben Sie Ihren vollständigen Namen ein',
    pf_emailAddress: 'E-Mail-Adresse *',
    pf_assessmentLanguage: 'Sprache der Bewertung',
    pf_emailPlaceholder: 'Geben Sie Ihre E-Mail ein',
    pf_invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    pf_yourAge: 'Ihr Alter *',
    pf_selectAge: 'Alter auswählen',
    pf_yearsUnit: 'Jahre',
    pf_dyslexiaTested: 'Wurden Sie auf Legasthenie getestet? *',
    pf_iAmDyslexic: 'Ja, offiziell diagnostiziert',
    pf_iAmNotDyslexic: 'Getestet und keine Legasthenie',
    pf_notKnown: 'Nicht bekannt',
    pf_parentName: 'Name des Elternteils *',
    pf_parentNamePlaceholder: 'Name des Elternteils eingeben',
    pf_childName: 'Name des Kindes *',
    pf_childNamePlaceholder: 'Name des Kindes eingeben',
    pf_childAgeLabel: 'Alter des Kindes *',
    pf_selectChildAge: 'Alter des Kindes auswählen',
    pf_childDyslexiaTested: 'Wurde Ihr Kind auf Legasthenie getestet? *',
    pf_yesHasDyslexia: 'Ja, offiziell diagnostiziert',
    pf_yesNoDyslexia: 'Getestet und keine Legasthenie',
    pf_noNotTested: 'Nein, noch nie getestet',
    pf_nativeLangQuestion: 'Welche Sprache sprechen Sie zu Hause?',
    pf_browserLangDetected: 'Browsersprache erkannt:',
    pf_availableInSystem: '✓ In unserem System verfügbar',
    pf_yesNative: 'Ja',
    pf_othersNative: 'Andere',
    pf_specifyNative: 'Bitte geben Sie Ihre Muttersprache an *',
    pf_selectNativePlaceholder: 'Wählen Sie Ihre Muttersprache',
    pf_selectNativeError: 'Bitte wählen Sie Ihre Muttersprache',
    pf_nativeLangNote: 'Dies hilft uns, genauere Bewertungsergebnisse basierend auf Ihrem sprachlichen Hintergrund zu liefern. Ihre Browsersprache ({lang}) wurde automatisch erkannt — wir verwenden Ihre IP-Adresse niemals zur Spracherkennung.',
    pf_forYourChild: 'Für Ihr Kind',
    pf_childExplanation: 'Der Computer schaut, wie du liest — dein Gesicht, deine Augen und dein Tippen — um deinen Lesestil zu verstehen. Deinen Daten passiert nichts Schlechtes. Dein Elternteil hat gesagt, dass es in Ordnung ist, und du kannst jederzeit aufhören.',
    pf_parentalConsentLabel: 'Elterliche Einwilligung *',
    pf_parentalConsentText: 'Ich willige in die Verarbeitung der Gesichts-, Augenbewegungs- und Tastaturinteraktionsdaten meines Kindes (oder meiner eigenen) für das Dyslexie-Screening und die Lernbewertung gemäß DSGVO und MDR ein.',
    pf_dataConsentLabel: 'Einwilligung zur Datenverarbeitung und Datenschutzerklärung *',
    pf_dataConsentText: 'Ich stimme der Verarbeitung meiner personenbezogenen Daten zu Screening-Zwecken zu.\nIch habe die Datenschutzerklärung und die Nutzungsbedingungen gelesen und stimme ihnen zu.',
    pf_consentPre: 'Ich stimme der',
    pf_consentPrivacyLink: 'Datenschutzrichtlinie',
    pf_consentBetween: 'und den',
    pf_consentTermsLink: 'Nutzungsbedingungen',
    pf_consentPost: 'zu, einschließlich der Datenverarbeitung für Screening-Zwecke.',
    pf_emailFailedTitle: 'E-Mail-Versand fehlgeschlagen',
    pf_checkYourEmail: 'Überprüfen Sie Ihre E-Mail',
    pf_emailSentDesc: 'Wir haben einen 6-stelligen Bestätigungscode an {email} gesendet. Bitte überprüfen Sie Ihren Posteingang und geben Sie den Code unten ein.',
    pf_emailFailedDesc: 'Senden an {email} fehlgeschlagen.',
    pf_tryAgain: 'Erneut versuchen',
    pf_sendingEmail: 'Senden...',
    pf_verificationCodeLabel: 'Bestätigungscode *',
    pf_enterCodePlaceholder: '6-STELLIGEN CODE EINGEBEN',
    pf_codeExpiry: 'Geben Sie den 6-stelligen Code aus Ihrer E-Mail ein. Der Code läuft in 15 Minuten ab.',
    pf_resendCode: 'Code nicht erhalten? Zum Erneut senden klicken',
    pf_sendingNewCode: 'Neuen Code senden...',
    pf_continue: 'Weiter',
    pf_continueToConsent: 'Weiter zur Einwilligung',
    pf_verifyEmailBtn: 'E-Mail verifizieren',
    pf_verifying: 'Überprüfen...',
    pf_processing: 'Verarbeiten...',
    pf_importantNotice: 'Wichtiger Hinweis',
    pf_disclaimer: 'DysTest ist ein digitales Screening-Tool zur Unterstützung der Früherkennung und Lerneinblicke. Es stellt keine medizinische Diagnose. Für eine offizielle Diagnose oder klinische Beratung wenden Sie sich bitte an qualifizierte Gesundheitsfachleute.',
            cg_readingAssessment: 'Lesestatistik',
    cg_whatsNext: 'Was kommt als Nächstes',
    cg_twoSections: 'Zwei kurze Abschnitte — eine Geschichte lesen, dann ein paar Fragen beantworten',
    cg_readStory: 'Die Geschichte lesen',
    cg_readStoryDesc: 'Nimm dir Zeit — lies in deinem eigenen Tempo',
    cg_answerQuestions: 'Ein paar Fragen beantworten',
    cg_answerQuestionsDesc: 'Schreibe deine Antworten in deinen eigenen Worten — kein Richtig oder Falsch',
    cg_exampleQuestion: 'Was passierte am Anfang der Geschichte?',
    cg_exampleAnswer: 'Der Junge ging in den Park…',
    cg_startReading: 'Lesen starten',
    cg_warmupGame: 'Aufwärmspiel',
    cg_matchHeading: 'Ordne das Wort dem Bild zu',
    cg_matchSubtitle: 'Klicke eine Wortkarte, dann das passende Bild, um das Paar zu vervollständigen',
    cg_startMatching: 'Matching starten!',
    cg_demoWord: 'Katze',
    cg_allMatched: 'Alle Paare gefunden!',
    cg_heatmapContinuing: 'Ihre Blick-Heatmap wird unten angezeigt — gleich weiter…',
    cg_lookAtTarget: '👁️ Schaut auf Ziel!',
    cg_lookAtDot: 'Schauen Sie auf den roten Punkt',
    cg_sRemaining: 's verbleibend',
    cg_skipFixation: 'Fixierung überspringen',
    cg_correct: '✓ Richtig!',
    cg_tryAgain: '✗ Erneut versuchen',
    cg_liveMetrics: 'Live-Metriken',
    cg_blinks: 'Blinzeln',
    cg_matched: 'Gefunden',
    cg_errors: 'Fehler',
    fpc_instruction: 'Schau auf jeden Punkt',
    fpc_dotsTotal: 'Punkte insgesamt — schau direkt auf jeden Punkt und halte deinen Blick. Es erfasst automatisch.',
    fpc_cancelCalibration: 'Kalibrierung abbrechen',
    fpc_clickMe: 'Klick mich!',
    fpc_eyeTrackingStarting: 'Eye-Tracking startet — Sie können bereits klicken!',
    fpc_calibrationComplete: 'Kalibrierung abgeschlossen!',
    fpc_trainingSamples: '{n} Trainingsbeispiele aufgezeichnet',
    fpc_allPointsDone: 'Alle Punkte erledigt!',
    fpc_pointOf: 'Punkt {current} von {total}',
    fpc_training: 'Training',
    fpc_inactive: 'Calibration inactive',
    fpc_savingCalibration: 'Kalibrierung wird gespeichert…',
    fpc_moveEyes: 'Bewege deine Augen zum Punkt…',
    fpc_noFace: '⚠️ Kein Gesicht erkannt — zentriere dein Gesicht vor der Kamera',
    fpc_missingIrisTitle: '⚠️ Irisdaten fehlten bei zu vielen Punkten',
    fpc_missingIrisBody: 'Mehrere Kalibrierungspunkte wurden übersprungen, da keine Iris-Orientierungspunkte erkannt wurden.',
    fpc_lowAccuracyTitle: 'Genauigkeit niedriger als erwartet',
    fpc_lowAccuracyBody: 'Der Kalibrierungsfehler ist höher als ideal. Dies kann die Blickverfolgungsgenauigkeit verringern.',
    fpc_redoCalibration: 'Kalibrierung wiederholen',
    fpc_continueAnyway: 'Trotzdem fortfahren',
    fpc_lookAtDot: 'Schau direkt auf den Punkt',
    fpc_dotReady: '✓ Punkt erfasst — weiter…',
    fpc_keepLooking: 'Schau weiter auf den Punkt — er wird automatisch erfasst',
    fpc_captured: '✓ Erfasst! Weiter zum nächsten…',
    fpc_checkingAccuracy: 'Genauigkeit prüfen',
    fpc_valGotIt: 'Erfasst! Weiter zum nächsten…',
    fpc_valHoldStill: 'Stillhalten — Daten werden erfasst…',
    fpc_valLookDot: 'Schau auf den Punkt — er wird orange, wenn er bereit ist',
    fpc_valCheck: 'PRÜF',

    acp_welcome: 'Willkommen, {name}!',
    acp_setupSubtitle: 'Lassen Sie uns Ihre Bewertung einrichten',
    acp_setupVerification: 'Einrichtungsverifizierung',
    acp_setupStepsDesc: 'Schließen Sie alle Schritte ab, um die Bewertung freizuschalten',
    acp_step1Title: 'Kamera aktiv',
    acp_step1Desc: 'Kamera startet automatisch — keine Aktion erforderlich',
    acp_step2Title: 'Kameraüberprüfung',
    acp_step2Desc: 'Kameraqualität und Stabilität überprüfen',
    acp_step3Title: 'Tipptest',
    acp_step3Desc: 'Tastaturfunktionalität überprüfen',
    acp_step4Title: 'Augenkalibrierung',
    acp_step4Desc: 'Augentracking-System kalibrieren',
    acp_eyeTrackingActive: '✓ Augentracking aktiv',
    acp_eyeTrackingError: '⚠ Augentracking-Fehler:',
    acp_startingEyeTracking: '⏳ Augentracking wird gestartet...',
    acp_cameraReady: '👁 Kamera bereit',
    acp_waitingForCamera: '📷 Kamera startet automatisch...',
    acp_stepDone: 'Fertig',
    acp_stepInProgress: 'In Bearbeitung',
    acp_checkingCameraStability: 'Kamerastabilität wird überprüft...',
    acp_cameraVerified: 'Kamera verifiziert ✓',
    acp_autoVerifyingCamera: 'Kamera wird automatisch verifiziert...',
    acp_waitingFaceDetection: 'Warten auf Gesichtserkennung...',
    acp_eyeTrackingStarting: 'Augentracking wird gestartet...',
    acp_calibrationInProgress: 'Kalibrierung läuft...',
    acp_eyeTrackingReady: 'Augentracking bereit ✓',
    acp_startingCalibration: 'Kalibrierung wird gestartet...',
    acp_distanceHint: 'Halte dein Gesicht mittig und still, höchstens 60 cm vom Bildschirm entfernt',
    acp_distanceLabel: 'max. 60 cm',
    acp_fpsTitle: 'Deine Kamera ist etwas langsam',
    acp_fpsBody: 'Sie liefert {fps} Bilder pro Sekunde; für Blickmessungen sind mindestens 10 nötig. Das hilft meist innerhalb von Sekunden:',
    acp_fpsVeryLow: 'Bei dieser Geschwindigkeit sind manche Augenmessungen eventuell nicht nutzbar; die anderen Aufgaben zählen trotzdem.',
    acp_fpsTipLight: 'Mach mehr Licht an oder setz dich mit dem Gesicht zum Fenster',
    acp_fpsTipCharger: 'Schließ das Ladegerät an (Energiesparen macht den Laptop langsamer)',
    acp_fpsTipApps: 'Schließ Videoanrufe und andere aufwendige Programme',
    acp_fpsCheckAgain: 'Erneut prüfen',
    acp_fpsChecking: 'Wird geprüft…',
    acp_fpsContinue: 'Trotzdem weiter',
    acp_preparingEyeTracking: 'Augentracking wird vorbereitet...',
    acp_cameraPreview: 'Kameravorschau',
    acp_noFaceDetected: 'Kein Gesicht erkannt',
    acp_live: 'LIVE',
    acp_cameraVerifiedTitle: 'Kamera verifiziert ✓',
    acp_cameraReadyTitle: 'Kamera bereit',
    acp_qualityCheckPassed: 'Qualitätsprüfung bestanden',
    acp_optimizedForAssessment: 'Für Bewertung optimiert',
    acp_verifiedBadge: 'Verifiziert',
    acp_readyBadge: 'Bereit',
    acp_assessmentMetrics: 'Bewertungsmetriken',
    acp_faceDistance: 'Gesichtsabstand',
    acp_goodDistance: 'Guter Abstand für die Bewertung',
    acp_searching: 'Suchen...',
    acp_lightLevel: 'Lichtniveau',
    acp_fps: 'FPS',
    acp_fpsExcellent: 'Ausgezeichnete Bildrate',
    acp_fpsGood: 'Gute Bildrate',
    acp_fpsModerate: 'Mäßige Bildrate',
    acp_fpsLow: 'Niedrige Bildrate',
    acp_fpsInitializing: 'Initialisierung...',
    acp_faceDetection: 'Gesichtserkennung',
    acp_faceDetected: '✓ Erkannt',
    acp_faceDetectedSub: 'Gesicht erfolgreich erkannt',
    acp_cameraQualityPassed: 'Kameraqualitätsprüfung bestanden. Bereit für den nächsten Schritt.',
    acp_visionWarnings: 'Visuelle Warnungen',
    acp_trackingMetrics: 'Tracking-Metriken',
    acp_headPitch: 'Kopfneigung:',
    acp_headYaw: 'Kopfdrehung:',
    acp_headRoll: 'Kopfroll:',
    acp_gazePoint: 'Blickpunkt:',
    acp_emotion: 'Emotion:',
    acp_confidence: 'Konfidenz:',
    acp_trackingId: 'Tracking-ID:',
    acp_faceId: 'Gesichts-ID:',
    acp_browser: 'Browser:',
    acp_os: 'OS:',
    acp_camera: 'Kamera:',
    acp_resolution: 'Auflösung:',
    acp_initializingTracking: 'Tracking-Metriken werden initialisiert...',
    acp_dataQuality: 'Datenqualität',
    acp_dataQualityExcellent: 'AUSGEZEICHNET',
    acp_dataQualityGood: 'GUT',
    acp_dataQualityFair: 'AUSREICHEND',
    acp_dataQualityDetecting: 'ERKENNUNG...',
    acp_dataQualityExcellentDesc: 'Optimal für Bewertung',
    acp_dataQualityGoodDesc: 'Gut für Bewertung',
    acp_dataQualityFairDesc: 'Akzeptable Qualität',
    acp_dataQualityDetectingDesc: 'Bedingungen analysieren',
    acp_faceMeshPoints: 'Gesichtsnetzpunkte',
    acp_completeFaceMesh: 'Vollständiges Gesichtsnetz',
    acp_detecting: 'Erkennung...',
    acp_typingTest: 'Tipptest',
    acp_typeQwerty: 'Tippen Sie {target} zur Tastaturüberprüfung',
    acp_verifyKeyboard: 'Tastaturfunktionalität überprüfen',
    acp_activeStatus: 'Aktiv',
    acp_lockedStatus: 'Gesperrt',
    acp_typeHere: 'Hier tippen...',
    acp_typingCompleted: '✓ Abgeschlossen! Weiter zum nächsten Schritt...',
    acp_keepTyping: 'Weiter tippen:',
    acp_remaining: 'verbleibend',
    acp_startTyping: 'Beginnen Sie mit dem Tippen der obigen Buchstaben',
    acp_completeCameraVerification: 'Kameraüberprüfung abschließen zum Entsperren',
    acp_lightingPerfect: 'Perfekte Beleuchtung für die Bewertung',
    acp_lightingSlightlyBright: 'Etwas zu hell — verringern Sie wenn möglich',
    acp_lightingTooBright: 'Zu hell — Beleuchtung/Bildschirmhelligkeit verringern',
    acp_lightingSlightlyDim: 'Etwas zu dunkel — erhöhen Sie wenn möglich',
    acp_lightingTooDim: 'Zu dunkel — Beleuchtung erhöhen',
    acp_positionFace: '👤 Positionieren Sie Ihr Gesicht im Kamerabild',
    acp_faceDetectedStarting: '✅ Gesicht erkannt — Verifizierung wird gestartet...',
    acp_adjustDistance: 'Passen Sie Ihren Abstand zur Kamera an',
    acp_moveFarther: 'Weiter von der Kamera entfernen',
    acp_distanceInRange: 'Abstand sieht gut aus',
    pdg_moveCloser: 'Näher an die Kamera heranrücken',
    pdg_moveFarther: 'Weiter von der Kamera entfernen',
    pdg_dismiss: 'Verwerfen',
    acp_noData: 'Keine Daten',
    acp_setupProgress: 'Einrichtungsfortschritt',
    acp_stepsComplete: '{n} von 4 Schritten abgeschlossen',
    acp_environment: 'Umgebung',
    acp_checkingEllipsis: 'Wird überprüft…',
    acp_waitingEllipsis: 'Warten…',
    acp_analysingConditions: 'Kamerabedingungen werden analysiert…',
    acp_positionFaceCamera: 'Positionieren Sie Ihr Gesicht vor der Kamera',
    acp_faceAligned: 'Gesicht ausgerichtet',
    shared_stepOf: 'Schritt {step} von {total}',
    shared_start: 'start',
    cal_introHeading: 'KALIBRIERUNG',
    cal_introSubtitle: 'Verfolge die Punkte und halte den Kopf ruhig',
    story_introHeading: 'LESEN UND FRAGEN',
    fpc_lookHere: '👆 Punkt anklicken um fortzufahren',
            pfp_chip_gdpr: 'DSGVO-konform',
    pfp_chip_mdr: 'MDR-konform',
    pfp_chip_noData: 'Keine Datenweitergabe',
    pfp_chip_languages: '8 Sprachen',
    kbv_header: 'Tastendynamik-Erfassung',
    kbv_interKey: 'Intervall zwischen Tasten',
    kbv_typingSpeed: 'Tippgeschwindigkeit',
        pfp_aiBadge: 'Blickverfolgung Legasthenie-Screening',
    pfp_whyBadge: 'Warum DysTest',
    mat_missionBadge: 'Unsere Mission & Technologie',
    mat_eyeBadge: 'Augenverfolgung',
    mat_kbdBadge: 'Tastenanschlag-Analyse',
    mat_ferBadge: 'Gesichtsausdruck',
    pfp_noBrowserFooter: 'Kein Konto erforderlich · Vollständig im Browser · Ergebnisse in <15 Minuten',
    eye_viz_landmarks: '478 Merkpunkte',
    eye_viz_irisFaceMesh: 'Iris + Gesichtsnetz',
    eye_viz_fps: '30 Bilder/s Echtzeit',
    eye_viz_validation: '9-Punkt + 4-Punkt Validierung',
    eye_viz_calibration: 'Klinische 13-Punkt-Kalibrierung',
    ran_anim_rapidNaming: 'Schnelles Benennen',
    ran_anim_predictor: 'Nr. 1 Legasthenie-Indikator',
    ran_anim_ageNormed: 'Altersnormierte Bewertung',
    ran_anim_zscore: 'z-Wert + Perzentile',
    acp_hideDetails: 'Details ausblenden ▲',
    acp_showDetails: 'Details anzeigen ▼',
    acp_moveCloser: 'näher heranrücken',
    acp_headLabel: 'Kopf',
    acp_setupTipsTitle: 'Schnelle Einrichtungstipps',
    acp_tip1: 'Sitzen Sie ~50 cm von Ihrem Bildschirm entfernt',
    acp_tip2: 'Sorgen Sie für gleichmäßige, helle Beleuchtung auf Ihrem Gesicht',
    acp_tip3: 'Halten Sie den Kopf gerade und schauen Sie direkt in die Kamera',
    acp_tip4: 'Nutzen Sie eine ruhige Umgebung für eine ungestörte Bewertung',
    acp_progressLabel: 'Fortschritt',

    priv_gdprTitle: 'DSGVO-konform',
    priv_gdpr1: 'Nachweisliche elterliche Zustimmung für Kinder unter 13 Jahren',
    priv_gdpr2: 'Datensparsamkeit und Zweckbindung',
    priv_gdpr3: 'Recht auf Auskunft, Berichtigung und Löschung von Daten',
    priv_gdpr4: 'Transparente Datenverarbeitung',
    priv_mdrTitle: 'An MDR ausgerichtet',
    priv_mdr1: 'Besonderer Schutz für schutzbedürftige Personen',
    priv_mdr2: 'Klinische Sicherheit und Leistung',
    priv_mdr3: 'Klare Unterscheidung zwischen Screening und Diagnose',
    priv_mdr4: 'Ethischer Umgang mit Gesundheitsdaten',
    priv_retentionTitle: 'Datenspeicherungsrichtlinie',
    priv_12months: '12 Monate',
    priv_12monthsDesc: 'Eye-Tracking-Koordinaten & Tastenanschläge',
    priv_24months: '24 Monate',
    priv_24monthsDesc: 'Analyse-Metadaten',
    priv_parentsControl: 'Elternkontrolle',
    priv_deleteAnytime: 'Jederzeit löschen',

    mat_headline1: 'MENSCHLICHES MITGEFÜHL.',
    mat_headline2: 'KÜNSTLICHE PRÄZISION',
    mat_subheadline: 'Gelebte Erfahrung und modernste KI verbinden, um Legasthenie-Screening',
    mat_subheadlineHighlight: 'für alle zugänglich zu machen',
    mat_whatTitle: 'WAS WIR TUN',
    mat_what1: 'Wir verbinden tiefes Fachwissen über Lese-Rechtschreib-Schwäche mit fortschrittlicher KI-Technologie. Nach jahrelanger Forschung haben wir diese Erkenntnisse einer adaptiven KI beigebracht.',
    mat_what2: 'Unsere KI führt intelligente, mehrschichtige Tests durch — jede Antwort wird mit Tausenden echter Lesemuster verglichen. Sie lernt in Echtzeit und stellt die richtigen Folgefragen.',
    mat_what3: 'Alles, um Familien die Klarheit zu geben, die sie brauchen, um den nächsten Schritt mit Zuversicht zu gehen.',
    mat_whyTitle: 'WARUM WIR DAS TUN',
    mat_why1: 'Stellen Sie sich vor, Ihr Kind steht vor denselben Leseschwierigkeiten wie Sie früher — aber jetzt hat es einen Namen: Legasthenie. Sie wollen Antworten, doch der erste Test kostet €750 bis €1.800 — für viele Familien unerreichbar.',
    mat_why2: 'Diese Realität bricht uns das Herz. Jedes Kind verdient es zu verstehen, wie es lernt. Jeder Elternteil verdient Antworten.',
    mat_why3: 'Deshalb sind wir hier — denn den eigenen Verstand zu verstehen sollte niemals ein Privileg sein. Es ist ein Menschenrecht.',
    mat_bgTitle: 'UNSER HINTERGRUND',
    mat_bg1: 'Wir haben selbst mit Legasthenie gelebt und über 20 Jahre im Bereich des barrierefreien Lesens geforscht. Durch die Verbindung dieser Erfahrungen mit KI haben wir ein einfaches, bezahlbares und lebensveränderndes Screening-Tool entwickelt.',
    mat_bg2: 'Unsere KI misst nicht nur Lesegeschwindigkeit oder zählt Fehler — sie versteht das Wie hinter jeder Augenbewegung, Pause und Korrektur. Sie betrachtet die kognitiven Prozesse, die Lesen so herausfordernd machen.',
    mat_techTitle: 'UNSERE TECHNOLOGIE',
    mat_tech1: 'Indem wir diese subtilen Unterschiede verstärken, lernt unser System, zwischen Legasthenie und anderen Leseschwächen mit außerordentlicher Präzision zu unterscheiden. Wir nutzen Deep Clustering — eine fortschrittliche Form des unüberwachten Lernens.',
    mat_tech2: 'Dieser mehrschichtige, querverweisende Ansatz bringt mehr Gewissheit als jede frühere Methode — tiefer und weiter als je zuvor.',
    mat_eyeTitle: 'Augenverfolgung',
    mat_eyeText: 'Wir messen Blickstabilität, Fixationsdauer und Sakkadenbewegungen, um zu erkennen, wie sich der visuelle Fokus beim Lesen verschiebt.',
    mat_kbdTitle: 'Tastatur-Dynamik',
    mat_kbdText: 'Tastenanschlag-Rhythmus, Zögern und Korrekturgeschwindigkeit decken Sequenzierungs- und phonologische Probleme auf, die typisch für Legasthenie sind.',
    mat_ferTitle: 'Gesichtsausdruck-Erkennung (FER)',
    mat_ferText: 'Subtile Ausdrücke offenbaren Frustration, Engagement oder Erleichterung — und helfen unserer KI, die emotionale Dimension hinter dem Leseprozess zu erkennen.',

    footer_about: 'Über uns',
    footer_blog: 'Publications',
    footer_contact: 'Kontakt',
    footer_faq: 'FAQ',
    footer_privacy: 'Datenschutz',
    footer_terms: 'Nutzungsbedingungen',
    footer_tagline: 'KI-gestützte Legasthenie-Erkennung mit Echtzeit-Iris-Tracking, Tastatur-Dynamik und Gesichtsausdrucks-Analyse — in 8 Sprachen verfügbar, vollständig im Browser.',
    footer_productHeading: 'Produkt',
    footer_legalHeading: 'Rechtliches',
    footer_mission: 'Entwickelt, um Legasthenie-Screening für alle zugänglich zu machen, in jeder Sprache.',
    footer_copyright: 'Alle Rechte vorbehalten',
    footer_madeWith: 'Mit Engagement für das Bewusstsein für Legasthenie erstellt',
    footer_allSystems: 'Alle Systeme betriebsbereit',

    fp_assessmentBadge: 'Letzter Schritt',
    fp_feedbackTitle: 'Teilen Sie eine letzte Notiz',
    fp_feedbackDesc: 'Optionales Feedback hilft uns, die Bewertungserfahrung zu verbessern.',
    fp_shareThoughts: 'Teilen Sie Ihre Gedanken',
    fp_optional: 'Optional',
    fp_words: 'Wörter',
    fp_corrections: 'Korrekturen',
    fp_speed: 'Geschwindigkeit',
    fp_feedbackPlaceholder: 'War etwas schwierig, unklar oder verbesserungswürdig?',
    fp_observationNotesTitle: 'Beobachtungsnotizen (optional)',
    fp_observationNotesDesc: 'Für die Eltern oder die Aufsichtsperson während des Tests: alles, was der Bildschirm nicht erfassen kann — Ablenkung, Müdigkeit, Weinen, Lärm oder alles andere, das zusammen mit den Ergebnissen festgehalten werden sollte.',
    fp_observationNotesPlaceholder: 'z. B. "Wirkte beim Wortschreibtest müde" oder "Wurde während Geschichte 1 von einem Geschwisterkind abgelenkt"',
    fp_generatingReport: 'Ihr Bericht wird erstellt…',
    fp_submitBtn: 'Abschließen und Bericht ansehen',
    fp_skipHint: 'Feedback ist optional. Fahren Sie fort, wenn Sie bereit sind.',
    fp_youNailedIt: 'Bewertung abgeschlossen',
    fp_reportGenerated: 'Ihr Bericht ist im Dashboard bereit.',
    fp_copySentTo: 'Zugangsdaten gesendet an',
    fp_welcomeBack: 'Bericht gespeichert',
    fp_newReportAdded: 'Zu Ihren Dashboard-Ergebnissen hinzugefügt.',
    fp_reportReady: 'Ihr Bericht ist fertig',
    fp_reportSubtitle: 'Vollständige Analyse, Blickbewegungsaufzeichnung & Legasthenie-Indikatoren',
    fp_openingReport: 'Ihr Bericht wird geöffnet…',
    fp_viewMyReport: 'Meinen Bericht ansehen',
    fp_signInLater: 'oder melden Sie sich später an bei',
    fp_saveForAccess: 'Für zukünftigen Zugriff speichern',
    fp_emailLabel: 'E-Mail',
    fp_passwordLabel: 'Passwort',
    fp_copied: 'Kopiert',
    fp_copy: 'Kopieren',
    fp_pwUpdated: 'Passwort erfolgreich aktualisiert',
    fp_setCustomPw: 'Eigenes Passwort festlegen',
    fp_newPwPlaceholder: 'Neues Passwort (mind. 4 Zeichen)',
    fp_save: 'Speichern',
    fp_cancel: 'Abbrechen',
    fp_signInLink: 'Dashboard öffnen →',
    fp2_saving: 'Ihre Ergebnisse werden gespeichert…',
    fp2_savingSub: 'Das dauert ein paar Sekunden. Bitte lassen Sie diese Seite geöffnet.',
    fp2_allDone: 'Fertig',
    fp2_reportReadySent: 'Der Bericht ist fertig. Wir haben die Zugangsdaten gesendet an',
    fp2_reportReadyReturning: 'Der Bericht ist fertig und wurde Ihrem Dashboard hinzugefügt.',
    fp2_passwordLine: 'Ihr Passwort (steht auch in der E-Mail):',
    fp2_openReport: 'Bericht öffnen',
    fp2_saveFailed: 'Ihre Ergebnisse konnten noch nicht gespeichert werden.',
    fp2_saveFailedSub: 'Prüfen Sie die Internetverbindung und versuchen Sie es erneut. Bitte lassen Sie diese Seite geöffnet.',
    fp2_tryAgain: 'Erneut versuchen',
    fp2_sessionTitle: 'Gibt es etwas zum Test, das wir wissen sollten?',
    fp2_sessionOptional: 'Optional · ändert das Ergebnis nicht',
    fp2_cTired: 'Müde oder abgelenkt',
    fp2_cCameraMic: 'Problem mit Kamera oder Mikrofon',
    fp2_cNoisy: 'Laut oder Unterbrechungen',
    fp2_cLanguage: 'Nicht die Erstsprache',
    fp2_cHelped: 'Jemand hat bei Antworten geholfen',
    fp2_cFroze: 'Seite hing oder musste neu laden',
    fp2_saveNotes: 'Notizen speichern',
    fp2_notesSaved: 'Notizen gespeichert',
    fp2_notesFailed: 'Die Notizen konnten nicht gespeichert werden. Bitte erneut versuchen.',
    fp_parentNote: '👨‍👩‍👧 Ein Hinweis für die Eltern',
    fp_parentNoteDesc: 'Die Beurteilung ist abgeschlossen. Teilen Sie bitte Ihre Beobachtungen darüber mit, wie Ihr Kind die Aufgaben heute angegangen ist (optional).',
    fp_screeningResult: 'Screening-Ergebnis',
    fp_riskTypical: 'Typisch — keine signifikanten Indikatoren',
    fp_riskBorderline: 'Grenzwertig — einige Indikatoren vorhanden',
    fp_riskHighRisk: 'Hohes Risiko — mehrere Indikatoren erkannt',
    fp_riskVeryHighRisk: 'Sehr hohes Risiko — starke Indikatoren in mehreren Bereichen',
    fp_confidence: 'Konfidenz',
    fp_keyFindings: 'Wichtigste Befunde',
    fp_disclaimer: 'Dies ist nur ein Screening-Instrument — keine klinische Diagnose. Bitte wenden Sie sich an einen zugelassenen Schulpsychologen für eine vollständige Beurteilung.',
    fp_notAssessed: 'Nicht bewertet',
    fp_percentile: '. Perzentil',
    fp_domainTypical: '✓ Typisch',
    fp_domainBorderline: '⚠ Grenzwertig',
    fp_domainHighRisk: '✗ Hohes Risiko',
    fp_aiReportTitle: 'KI-personalisierter Bericht',
    fp_aiGenerating: 'DysTest AI erstellt Ihren personalisierten Bericht…',
    fp_aiGenerated: 'Erstellt von DysTest AI · Keine klinische Diagnose',
    fp_aiAnalysing: 'Beurteilungsdaten werden analysiert…',
    fp_strengths: 'Stärken',
    fp_areasToSupport: 'Förderungsbedarf',
    fp_noDifficulties: 'Keine signifikanten Schwierigkeiten erkannt.',
    fp_eyeTracking: 'Blickverfolgung:',
    fp_recommendations: 'Empfehlungen',
    fp_nextStep: 'Nächster Schritt:',
    pp_title: 'Datenschutzrichtlinie',
    pp_bannerTitle: 'Ihre Privatsphäre ist Heilig',
    pp_bannerDesc: 'Wir glauben, dass Ihre persönlichen Daten Ihnen gehören, nicht uns zum Verkauf. Wir sammeln nur das Notwendige für eine genaue Legasthenie-Untersuchung und schützen es mit branchenführender Sicherheit. Sie haben stets vollständige Kontrolle über Ihre Informationen.',
    pp_contactTitle: 'Fragen zu Ihrer Privatsphäre?',
    pp_contactDesc: 'Wir setzen uns für Transparenz ein. Wenn Sie Fragen dazu haben, wie wir Ihre Daten verarbeiten, sind wir hier, um zu helfen.',
    pp_privacyInquiries: 'Datenschutzanfragen',
    pp_generalSupport: 'Allgemeiner Support',
    pp_acknowledgment: 'Durch die Nutzung des DysTest-Dienstes bestätigen Sie, dass Sie diese Datenschutzrichtlinie gelesen und verstanden haben.',
    tos_title: 'Nutzungsbedingungen',
    tos_missionTitle: 'Unsere Mission',
    tos_missionDesc: 'Den eigenen Verstand zu verstehen sollte kein Luxus sein — es ist ein Menschenrecht. Unsere Mission ist es, Legasthenie-Screening für jede Familie zugänglich, erschwinglich und genau zu machen.',
    tos_contactTitle: 'Fragen zu Diesen Bedingungen?',
    tos_contactDesc: 'Wir sind hier, um zu helfen. Wenn Sie Fragen zu unseren Nutzungsbedingungen haben, zögern Sie nicht, uns zu kontaktieren.',
    tos_acknowledgment: 'Durch die Nutzung des DysTest-Dienstes bestätigen Sie, dass Sie diese Nutzungsbedingungen gelesen, verstanden haben und damit einverstanden sind.',
    shared_quickNav: 'Schnelle Navigation',
    shared_backHome: '← Zurück zur Startseite',
    shared_effectiveDate: 'Gültigkeitsdatum: 30. Oktober 2025',
    shared_lastUpdated: 'Letzte Aktualisierung: 30. Oktober 2025',
    shared_footerTagline: 'Legasthenie-Tests genau, zugänglich und erschwinglich machen.',
    shared_website: 'Website',
    shared_email: 'E-Mail',
    blog_knowledgeBadge: 'DysTest Wissenszentrum',
    blog_title: 'DysTest Blog',
    blog_subtitle: 'Expertenwissen über Legasthenie, Lernschwierigkeiten und wie KI die Früherkennung und Unterstützung revolutioniert',
    blog_searchPlaceholder: 'Artikel über Legasthenie, Lernschwierigkeiten, KI-Bewertung suchen...',
    blog_catAll: 'Alle',
    blog_catUnderstanding: 'Legasthenie verstehen',
    blog_catEarlyDetection: 'Früherkennung',
    blog_catTechnology: 'Technologie',
    blog_catNews: 'Neuigkeiten',
    blog_featuredBadge: '⭐ Empfohlen',
    blog_featuredArticles: 'Empfohlene Artikel',
    blog_allArticles: 'Alle Artikel',
    blog_article: 'Artikel',
    blog_articles: 'Artikel',
    blog_readMore: 'Mehr lesen →',
    blog_found: 'Gefunden',
    blog_forQuery: 'für',
    blog_noResults: 'Keine Artikel gefunden',
    blog_noResultsDesc: 'Versuchen Sie, Ihre Suche oder Filterkriterien anzupassen',
    blog_clearFilters: 'Filter löschen und alle Artikel anzeigen',
    blog_newsletterTitle: 'Bleiben Sie über Legasthenie-Forschung informiert',
    blog_newsletterDesc: 'Erhalten Sie die neuesten Erkenntnisse zu Legasthenie-Forschung, KI-Technologie und Lernstrategien in Ihrem Posteingang.',
    blog_newsletterBtn: 'Updates abonnieren',
    blog_newsletterPrivacy: 'Kein Spam. Abmeldung jederzeit möglich. Wir respektieren Ihre Privatsphäre.',
    blog_newsletterEmailPlaceholder: 'E-Mail-Adresse eingeben',
    blog_newsletterSending: 'Wird gesendet…',
    blog_newsletterCheckInbox: 'Fast geschafft — prüfen Sie Ihr Postfach und klicken Sie zur Bestätigung auf den Link.',
    blog_newsletterError: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.',
    nws_working: 'Einen Moment…',
    nws_confirmedTitle: 'Sie sind angemeldet',
    nws_confirmedBody: 'Vielen Dank! Sie erhalten neue Blogbeiträge, technische Papiere und unseren Newsletter. Jede E-Mail enthält einen Abmeldelink.',
    nws_wasUnsubscribed: 'Diese Adresse wurde abgemeldet. Melden Sie sich im Blog erneut an, um Neuigkeiten zu erhalten.',
    nws_unsubTitle: 'Von DysTest-Neuigkeiten abmelden?',
    nws_unsubBody: 'Sie erhalten dann keine neuen Blogbeiträge, technischen Papiere oder Newsletter mehr.',
    nws_unsubBtn: 'Abmelden',
    nws_unsubDoneTitle: 'Sie sind abgemeldet',
    nws_unsubDoneBody: 'Sie erhalten keine Neuigkeiten mehr. Anders entschieden? Im Blog können Sie sich erneut anmelden.',
    nws_invalidTitle: 'Dieser Link ist ungültig',
    nws_invalidBody: 'Der Link ist vielleicht alt oder unvollständig. Im Blog können Sie sich erneut anmelden.',
    nws_toBlog: 'Zum Blog',
    blog_backToArticles: 'Zurück zu den Artikeln',
    blog_loadingArticle: 'Artikel wird geladen...',
    blog_articleNotFound: 'Artikel nicht gefunden',
    blog_ctaTitle: 'Bereit, mehr zu erfahren?',
    blog_ctaDesc: 'Entdecken Sie, wie DysTest Lernschwierigkeiten erkennen und das Potenzial jedes Kindes mit unserer KI-gestützten Bewertung freisetzen kann.',
    blog_tryDystest: 'DysTest-Bewertung ausprobieren',
    blog_readMoreArticles: 'Mehr Artikel lesen',
    faq_badge: 'Fragen? Wir haben die Antworten',
    faq_title: 'Häufig gestellte Fragen',
    faq_subtitle: 'Alles, was Sie über unsere',
    faq_subtitleHighlight: 'Blickverfolgung Legasthenie-Früherkennung',
    faq_searchPlaceholder: "Fragen suchen... (z. B. 'Kosten', 'Datenschutz', 'wie lange')",
    faq_mostPopular: 'Beliebteste Fragen',
    faq_noResults: 'Keine Fragen gefunden, die Ihrer Suche entsprechen.',
    faq_clearFilters: 'Filter löschen',
    faq_stillHave: 'Noch Fragen?',
    faq_supportDesc: 'Unser Support-Team hilft Ihnen gerne weiter. Wir antworten in der Regel innerhalb von 24 Stunden.',
    faq_contactSupport: 'Support kontaktieren',
    faq_startScreening: 'Screening starten',
    faq_catAll: 'Alle',
    faq_related: 'Verwandt:',
    about_badge: 'Unsere Geschichte',
    about_title: 'Über DysTest',
    about_subtitle: 'Wir glauben, dass jedes Kind es verdient, verstanden zu werden — nicht nur getestet.',
    about_backHome: '← Zurück zur Startseite',
    about_ctaTitle: 'Bereit anzufangen?',
    about_ctaDesc: 'Starten Sie noch heute ein einfühlsames Screening für Ihr Kind und entdecken Sie, wie DysTest das Potenzial jedes Lernenden erschließt.',
    about_startScreening: 'Screening starten',
    about_startAssessment: 'Jetzt starten',
    about_navWhy: 'Warum DysTest Existiert',
    about_navMissionValues: 'Mission & Werte',
    about_navTechnology: 'Technologie',
    about_navTeam: 'Die Menschen Hinter DysTest',
    ran_audio_preLetter: 'Buchstabenbenennung. Lesen Sie jede Reihe von Buchstaben laut vor, so schnell wie möglich.',
    ran_audio_preDigit: 'Jetzt Ziffern. Lesen Sie jede Reihe von Zahlen laut vor, so schnell wie möglich.',
    ran_audio_preColor: 'Jetzt Farben. Nennen Sie die Farbe jedes Feldes laut, so schnell wie möglich.',
    ran_audio_preObject: 'Jetzt Gegenstände. Benennen Sie jedes Bild laut, so schnell wie möglich.',
    ran_audio_runLetter: 'Lesen Sie jeden Buchstaben laut vor, so schnell wie möglich.',
    ran_audio_runDigit: 'Lesen Sie jede Zahl laut vor, so schnell wie möglich.',
    ran_audio_runColor: 'Nennen Sie die Farbe jedes Feldes laut, so schnell wie möglich.',
    ran_audio_runObject: 'Benennen Sie jedes Bild laut, so schnell wie möglich.',
    ran_audio_practice: 'Lass uns üben. Sag jeden Buchstaben laut.',
    ran_intro_t1_heading: 'Lass uns Buchstaben sagen! 🔤',
    ran_intro_t1_desc1: 'Du siehst große Buchstaben auf dem Bildschirm.',
    ran_intro_t1_desc2: 'Sag jeden so laut und so schnell wie möglich!',
    ran_intro_heading: 'RAN',
    ran_intro_desc1: 'Sie sehen Reihen von Buchstaben, Ziffern, Farben und Gegenständen. Lesen Sie jede Reihe so schnell wie möglich laut vor — von links nach rechts.',
    ran_intro_desc2: 'Der Prüfer drückt Nächste Reihe, wenn Sie fertig sind. Wir üben zuerst kurz.',
    ran_intro_labLetters: 'Buchstaben',
    ran_intro_labDigits: 'Ziffern',
    ran_intro_labColors: 'Farben',
    ran_intro_labObjects: 'Gegenstände',
    ran_practice_t1_heading: 'Kannst du diese sagen? 👀',
    ran_practice_heading: 'Übung',
    ran_practice_t1_desc: 'Sag jeden Buchstaben laut. Fange links an!',
    ran_practice_desc: 'Lesen Sie diese Buchstabenreihe laut vor, von links nach rechts. Der Prüfer tippt auf Nächste Reihe, wenn Sie fertig sind.',
    ran_practice_hint: 'Sag: "a · o · s · p · k" — dann tippe auf die Schaltfläche unten.',
    ran_btn_try: "Los geht's! 🎉",
    ran_btn_practise: 'Lass uns üben',
    ran_btn_skip: 'Überspringen',
    ran_btn_gotIt: 'Verstanden — Buchstaben starten →',
    ran_btn_begin: 'Beginnen — Reihe 1 lesen →',
    ran_btn_nextRow: 'Nächste Reihe',
    ran_btn_continue: 'Weiter',
    ran_preLetter_title: 'Buchstabenbenennung  (RAN-L)',
    ran_preLetter_subtitle: '50 Buchstaben · 5 Reihen à 10. Lesen Sie jede Reihe so schnell wie möglich laut vor.',
    ran_preLetter_detail: 'Der Prüfer tippt nach jeder Reihe auf Nächste Reihe.',
    ran_preLetter_btn: 'Raster anzeigen →',
    ran_preDigit_title: 'Buchstaben fertig! Jetzt Ziffern  (RAN-D)',
    ran_preDigit_subtitle: 'Dieselbe Aufgabe mit Ziffern: 2 · 4 · 5 · 7 · 8',
    ran_preDigit_detail: '50 Ziffern · 5 Reihen à 10 · gleiche Regeln.',
    ran_preDigit_btn: 'Ziffern starten →',
    ran_preColor_title: 'Ziffern fertig! Jetzt Farben  (RAN-C)',
    ran_preColor_subtitle: 'Nennen Sie die Farbe jedes Feldes laut, so schnell wie möglich.',
    ran_preColor_detail: '50 farbige Felder · 5 Reihen à 10 · gleiche Regeln.',
    ran_preColor_btn: 'Farben starten →',
    ran_preObject_title: 'Farben fertig! Jetzt Gegenstände  (RAN-O)',
    ran_preObject_subtitle: 'Benennen Sie jedes Bild laut, so schnell wie möglich.',
    ran_preObject_detail: '50 Gegenstände · 5 Reihen à 10 · gleiche Regeln.',
    ran_preObject_btn: 'Gegenstände starten →',
    ran_done_t1_heading: 'Tolle Arbeit! 🌟',
    ran_done_heading: 'Alle Benennungsaufgaben abgeschlossen!',
    ran_done_t1_desc: 'Du hast alle Buchstaben gesagt!',
    ran_done_desc: 'Hier sind die Ergebnisse:',
    ran_badge: 'Schnellbenennungstest',
    ran_intro_watchDemo: '👀 Schau, wie es funktioniert',
    ran_intro_t1_lead: 'Schau jeden Buchstaben an und sag ihn so schnell wie möglich laut — von links nach rechts!',
    ran_intro_step1: 'Schau dir die Reihe an',
    ran_intro_step2: 'Sag jedes Element laut',
    ran_intro_step3: 'Geh so schnell wie möglich!',
    ran_intro_demoLabel: 'Sag jedes Element laut, so schnell wie möglich!',
    ran_btn_start: 'Start 🚀',
    ran_btn_tapStart: 'Klicken, um Reihe 1 zu starten',
    ran_btn_listening: 'Zuhören…',
    ran_btn_repeat: 'Anweisung wiederholen',
    ran_processing: 'Verarbeitung…',
    ran_transcribing: 'Audio mit Whisper transkribieren…',
    ran_transcribingDesc: 'Sprachgenauigkeit wird analysiert — das dauert ein paar Sekunden',
    ran_stat_totalTime: 'Gesamtzeit',
    ran_stat_itemsPerSec: 'Elemente/s',
    ran_stat_avgItem: 'Ø Element',
    ran_stat_mistakes: 'Fehler',
    ran_paceHint: 'Hervorgehoben = aktuelle Reihe  ·  Der Bewerter bestimmt das Tempo',
    ran_running_letter: '🔤 RAN-L — Buchstaben',
    ran_running_digit: '🔢 RAN-D — Ziffern',
    ran_running_color: '🎨 RAN-C — Farben',
    ran_running_object: '🦎 RAN-O — Objekte',
    ran_header_letter: 'RAN-L',
    ran_header_digit: 'RAN-D',
    ran_header_color: 'RAN-C',
    ran_header_object: 'RAN-O',

    nav_home: 'Startseite',
    nav_about: 'Über uns',
    nav_resources: 'Ressourcen',
    nav_startAssessment: 'Bewertung starten',
    nav_langMenuTitle: 'Sprache der Bewertung',
    nav_langMenuHint: 'Geschichten und Anweisungen folgen dieser Sprache',
    nav_techPapers: 'Fachartikel',
    nav_blog: 'Blog',
    nav_guides: 'Leitfäden',
    nav_faq: 'FAQ',

        wwt_badge: 'Wortschreibtest',
    wwt_introTitle: 'Merke dir das Wort und tippe es',
    wwt_introDesc: 'Ein Wort wird 5 Sekunden lang angezeigt — dann löscht es sich Buchstabe für Buchstabe und du tippst es aus dem Gedächtnis',
    wwt_demoHint: 'Das Wort verschwindet — du tippst es aus dem Gedächtnis',
    wwt_startWriting: "Los geht's!",
    wwt_rememberWord: 'Merke dir dieses Wort',
    wwt_watchCountdown: 'Schau auf den Countdown — dann schreibe es aus dem Gedächtnis',
    wwt_typeWord: 'Schreibe das Wort, das du gesehen hast',
    wwt_pressEnter: 'Tippe es ein und drücke Enter oder Weiter',
    wwt_nextWord: 'Nächstes Wort',
    wwt_finish: 'Fertig',
    wwt_done: 'Gut gemacht!',
    wwt_correct: 'Wörter richtig',
    wwt_continue: 'Weiter',
    wwt_wordOf: 'Wort {current} von {total}',
    form_badgeText: 'Schritt 1/8: Registrieren',
    form_heading: 'Registrieren & Beginnen',
    form_privacyNote: 'Ihre Daten sind durch die DSGVO- und MDR-Vorschriften geschützt. Es werden keine personenbezogenen Daten an Dritte weitergegeben.',

    // ── Microphone check panel (mic_*) ───────────────────────────────────
    mic_title: 'Mikrofon-Check',
    mic_sub_checking: 'Mikrofon wird überprüft…',
    mic_sub_ready: 'Mikrofon bereit — tippe auf Test zum Aufnehmen',
    mic_sub_recording: 'Aufnahme läuft… jetzt sprechen',
    mic_sub_retry: 'Das haben wir nicht ganz gehört — versuche es erneut',
    mic_sub_passed: 'Mikrofon funktioniert einwandfrei!',
    mic_sub_denied: 'Mikrofonzugriff verweigert',
    mic_pleaseSpeak: '🗣️ Bitte jetzt sprechen…',
    mic_retryBody: 'Wir konnten dich nicht deutlich hören. Sprich etwas lauter und versuche es erneut.',
    mic_testBtn: 'Mikrofon testen',
    mic_tryAgain: 'Erneut versuchen',
    mic_continueBtn: 'Weiter',
    mic_skipDenied: 'Überspringen (kein Mikrofon)',
    mic_skip: 'Mikrofon-Check überspringen',
    ud_myDashboard: 'Mein Dashboard',
    ud_myAssessmentReports: 'Meine Bewertungsberichte',
    ud_noAssessmentsFound: 'Keine abgeschlossenen Bewertungen gefunden.',
    ud_assessmentsFoundSingular: '1 abgeschlossene Bewertung gefunden.',
    ud_assessmentsFoundPlural: '{n} abgeschlossene Bewertungen gefunden.',
    ud_loadError: 'Ihre Bewertungen konnten nicht geladen werden. Überprüfen Sie Ihre Verbindung und aktualisieren Sie die Seite.',
    ud_serviceUnavailable: 'Der Server ist vorübergehend nicht verfügbar (503). Bitte warten Sie einen Moment und aktualisieren Sie die Seite.',
    ud_progressOverTime: 'Fortschritt im Laufe der Zeit',
    ud_longitudinalSubtitle: '{n} Bewertungen · zusammengesetzter Z-Score-Trend',
    ud_typical: 'Typisch (z ≥ −0,5)',
    ud_borderline: 'Grenzwertig (z < −0,5)',
    ud_highRisk: 'Hohes Risiko (z < −1,0)',
    ud_veryHighRisk: 'Sehr hohes Risiko (z < −1,5)',
    ud_noAssessmentsFor: 'Keine Bewertungen gefunden für',
    ud_completeAssessment: 'Schließen Sie eine Bewertung ab, um Ihre Ergebnisse hier zu sehen.',
    ud_startAssessment: 'Bewertung starten',
    ud_assessmentReport: 'Bewertungsbericht',
    ud_completed: 'Abgeschlossen',
    ud_accuracy: 'GENAUIGKEIT',
    ud_blinks: 'BLINZELN',
    ud_questions: 'FRAGEN',
    ud_rawData: 'Rohdaten (JSON)',
    ud_tabEyeTracking: 'Augenverfolgung',
    ud_tabRan: 'RAN-Analyse',
    ud_tabStory: 'Geschichtenanalyse',
    ud_gazePlaybackTitle: 'Augenverfolgung wiedergeben — 3 Modi: Raster · Heatmap · Pfad',
    ud_noGazeData: 'Keine Augenverfolgungsdaten für diese Bewertung verfügbar.',
    ud_gazeDataNote: 'Augenverfolgungsdaten werden während der Live-Bewertungssitzung erfasst und mit dem Bericht gespeichert.',
    ud_ranTitle: 'RAN — Ergebnisse der schnellen automatisierten Benennung',
    ud_totalTime: 'Gesamtzeit',
    ud_rawSpeed: 'Rohgeschwindigkeit',
    ud_correctedSpeed: 'Korrigierte Geschwindigkeit',
    ud_errors: 'Fehler',
    ud_rowTimings: 'Zeilenzeiten',
    ud_transcriptComparison: 'Transkriptvergleich',
    ud_row: 'Zeile',
    ud_audioNote: 'Audiowiedergabe ist im vollständigen ZIP-Bericht verfügbar · Vollständigen Bericht (ZIP) oben herunterladen',
    ud_storyTitle: 'Geschichtslese-Analyse',
    ud_story1Label: 'Geschichte 1 — Lesephase',
    ud_story2Label: 'Geschichte 2 — Lesephase',
    ud_readingTime: 'Lesezeit',
    ud_fixations: 'Fixierungen',
    ud_regressions: 'Regressionen',
    ud_avgFixation: 'Durchschn. Fixierung',
    ud_saccades: 'Sakkaden',
    ud_blinkRate: 'Blinzelrate',
    ud_gazeStoryTitle: 'Augenverfolgung — Geschichtenseiten',
    ud_noStoryGaze: 'Augenverfolgungsdaten der Geschichte für diese Bewertung nicht verfügbar.',
    ud_footer: 'Ihre Daten werden sicher nur auf diesem Gerät gespeichert.',
    ud_changePassword: 'Passwort ändern',
    ud_changePasswordDesc: 'Legen Sie ein neues Passwort für Ihr Konto fest. Sie verwenden es beim nächsten Mal, wenn Sie sich anmelden.',
    ud_passwordUpdated: 'Passwort erfolgreich aktualisiert',
    ud_newPasswordPlaceholder: 'Neues Passwort (min. 4 Zeichen)',
    ud_saving: 'Speichern…',
    ud_saveNewPassword: 'Neues Passwort speichern',
    ud_passwordTooShort: 'Das Passwort muss mindestens 4 Zeichen lang sein.',
    ud_passwordUpdateFailed: 'Passwort konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
    ud_accuracySuffix: 'Genauigkeit',
    acp_tabCamera: 'Kamera',
    acp_tabKeyboard: 'Tastatur',
    acp_tabMicrophone: 'Mikrofon',
    acp_checkingCameraQuality: 'Kameraqualität wird geprüft — das dauert einige Sekunden',
    acp_allChecksPassed: 'Alle Prüfungen bestanden!',
    acp_allSystemsReady: 'Kamera, Tastatur und Mikrofon sind bereit.',
    mini_step: 'Schritt',
    scp_setupComplete: '🎉 Einrichtung abgeschlossen!',
    scp_allSetSubtitle: 'Sie sind bereit für die Legasthenie-Bewertung',
    scp_setupQualityScore: 'Einrichtungsqualitätsbewertung',
    scp_excellentSetup: 'Hervorragende Einrichtungsqualität für eine genaue Bewertung',
    scp_completedSteps: '✅ Abgeschlossene Schritte',
    scp_cameraReadiness: 'Kamerabereitschaft',
    scp_cameraStabilityPassed: '10-Sekunden-Stabilitätsprüfung bestanden',
    scp_keyboardCapture: 'Tastaturerfassung',
    scp_keystrokeData: 'Klinische Tastaturanschlagdaten erfasst',
    scp_eyeCalibration: 'Augenkalibrierung',
    scp_calibrationCompleted: 'Kalibrierung abgeschlossen ({pct}% Genauigkeit)',
    scp_whatsNext: 'Was kommt als Nächstes?',
    scp_whatsNextBody: 'Sie beginnen mit der Lesebewertung, bei der wir Ihre Augenbewegungen, Gesichtsausdrücke und Lesemuster analysieren, um ein umfassendes Legasthenie-Screening durchzuführen.',
    scp_startAssessment: 'Legasthenie-Bewertung starten',
    scp_startingAssessment: 'Bewertung wird gestartet...',
    scp_estimatedTime: 'Geschätzte Zeit: 10-15 Minuten',

    // UserDashboard Berichtsraster
    ud_view: 'Ansehen',
    ud_report_userInfo: 'Benutzerinformationen',
    ud_report_envSetup: 'Umgebungseinrichtung',
    ud_report_wordIcon: 'Wort-Symbol-Zuordnung',
    ud_report_ran: 'RAN-Analyse',
    ud_report_story: 'Geschichtenanalyse',
    ud_report_wordWriting: 'Wortschreiben',
    ud_report_feedback: 'Rückmeldung',
    ud_report_summary: 'Zusammenfassung',
    ul_platform: 'Legasthenie-Bewertungsplattform',
    ul_invalidCredentials: 'Ungültige E-Mail-Adresse oder ungültiges Passwort. Prüfen Sie die Zugangsdaten, die am Ende Ihrer Bewertung angezeigt wurden.',
    ul_loginFailed: 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    ul_resetFailed: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    ul_backToSignIn: 'Zurück zur Anmeldung',
    ul_checkEmail: 'Prüfen Sie Ihre E-Mail',
    ul_smtpDevNotice: 'SMTP nicht konfiguriert (Dev). Temporäres Passwort:',
    ul_resetSent: 'Wenn {email} registriert ist, ist ein neues Passwort unterwegs.',
    ul_signIn: 'Anmelden',
    ul_resetPassword: 'Passwort zurücksetzen',
    ul_resetPasswordDesc: 'Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen ein neues Passwort.',
    ul_emailAddress: 'E-Mail-Adresse',
    ul_emailPlaceholder: 'ihre@email.com',
    ul_sending: 'Wird gesendet…',
    ul_sendNewPassword: 'Neues Passwort senden',
    ul_welcomeBack: 'Willkommen zurück',
    ul_signInSubtitle: 'Melden Sie sich an, um Ihre Bewertungsergebnisse anzusehen',
    ul_password: 'Passwort',
    ul_passwordPlaceholder: 'Ihr Passwort',
    ul_hidePassword: 'Passwort ausblenden',
    ul_showPassword: 'Passwort anzeigen',
    ul_forgotPassword: 'Passwort vergessen?',
    ul_signingIn: 'Anmeldung läuft…',
    ul_signInDashboard: 'Im Dashboard anmelden',
    ul_firstTime: 'Zum ersten Mal hier? Ihr Konto wurde nach Ihrer Bewertung automatisch erstellt. Prüfen Sie Ihre E-Mail auf die Anmeldedaten.',
    ul_footer: 'DSGVO- & MDR-konform · Kein Video gespeichert',

    mg_title: 'Kurz durchhalten – für die Wissenschaft!',
    mg_body: 'DysTest analysiert deine Augenbewegungen (pixelgenau!), deine Tippgeschwindigkeit und deine Stimme bis auf die Millisekunde.\n\nSuperschlaue Technik – aber sie hat eine Schwäche: Sie funktioniert nicht, wenn dein Bildschirm in deiner Hand hin und her wackelt. Klapp also kurz einen Laptop oder Computer auf, damit das Ergebnis zuverlässig ist!',
    mg_howTo: 'So geht es los',
    mg_step1: 'Öffnen Sie dystest.com auf einem Laptop oder Desktop-Computer',
    mg_step2: 'Stellen Sie sicher, dass Webcam und Tastatur angeschlossen sind',
    mg_step3: 'Verwenden Sie für beste Ergebnisse Chrome oder Firefox',
    mg_returnHome: 'Zurück zur Startseite',
    mg_shareLink: 'Link an mich senden',
    mg_copyLink: 'Link kopieren',
    mg_linkCopied: 'Link kopiert',
    mg_alreadyDone: 'Schon einen Test gemacht?',
    mg_loginLink: 'Anmelden, um den Bericht zu sehen',
    mg_emailLabel: 'Ihre E-Mail-Adresse',
    mg_emailPlaceholder: 'name@beispiel.de',
    mg_emailSend: 'Senden',
    mg_emailSent: 'Gesendet! Öffnen Sie die E-Mail am Laptop oder Computer, um den Test zu starten.',
    mg_emailError: 'Die E-Mail konnte nicht gesendet werden. Prüfen Sie die Adresse und versuchen Sie es erneut.',
};

export default de;
